module.exports = __webpack_public_path__ + "static/media/iconfont.c5a8e0e4.eot";